import { Type } from 'typebox';
import { TypeBoxShortIsoCalendarDateFormat } from '../../utils/register-typebox-short-iso-calendar-date-format.js';
import { InstantMessage } from './instant-message.js';
export const DailyMessages = Type.Object({
    subjectKey: Type.String({ minLength: 1 }),
    date: Type.String({ format: TypeBoxShortIsoCalendarDateFormat }),
    revision: Type.Integer(),
    messages: Type.Array(InstantMessage)
});
